import { Check } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const benefits = [
  "Cocina casera con sabor auténtico",
  "Excelente relación calidad-precio (20–30 € por persona)",
  "Ambiente familiar y cómodo",
  "Servicio cercano y atención personalizada",
  "Ideal para comidas diarias, celebraciones o encuentros sociales",
  "Valorado positivamente por cientos de clientes satisfechos",
];

const BenefitsSection = ({ onReservar }) => {
  const leftRef = useScrollAnimation();
  const rightRef = useScrollAnimation();

  return (
    <section className="py-24 md:py-36 bg-[#0a0a0a] overflow-hidden" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16 md:gap-24 items-center">
          {/* Image left */}
          <div ref={leftRef} className="fade-in-left relative order-2 md:order-1">
            <img
              src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80"
              alt="Platos del restaurante"
              className="w-full h-[500px] object-cover"
            />
            {/* Price badge */}
            <div className="absolute -bottom-6 -right-6 bg-gold p-8 hidden md:flex flex-col items-center justify-center">
              <span className="font-heading text-3xl font-bold text-black leading-none">20–30€</span>
              <span className="text-black text-xs tracking-widest uppercase mt-1">por persona</span>
            </div>
          </div>

          {/* Benefits list right */}
          <div ref={rightRef} className="fade-in-right order-1 md:order-2">
            <span className="text-gold text-xs tracking-[0.4em] uppercase font-body">Por qué elegirnos</span>
            <div className="h-px w-12 bg-gold mt-3 mb-8" />
            <h2 className="font-heading text-4xl md:text-5xl text-[#ededed] leading-tight mb-10">
              Razones para<br />
              <span className="italic text-gold-dark">volver siempre</span>
            </h2>

            <ul className="space-y-5">
              {benefits.map((benefit, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 border border-gold flex items-center justify-center mt-0.5">
                    <Check size={12} className="text-gold" />
                  </div>
                  <span className="font-body text-[#a3a3a3] text-base leading-relaxed">{benefit}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={onReservar}
              data-testid="benefits-reservar-btn"
              className="mt-10 bg-gold text-black font-bold text-xs tracking-widest uppercase px-8 py-4 rounded-[20px] hover:bg-gold-dark transition-all duration-300"
            >
              Reservar Mesa
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
